import { CHECKBOX_DEFAULT_MODE } from '../Checkbox/Checkbox.constants';
// Constants.
// -----------------------------------------------------------------------------
/** Default 'disabled' value. */
export const CHECKBOXGROUP_DEFAULT_DISABLED = false;
/** Default 'direction' value. */
export const CHECKBOXGROUP_DEFAULT_DIRECTION = 'column';
/** Default 'mode' value. */
export const CHECKBOXGROUP_DEFAULT_MODE = CHECKBOX_DEFAULT_MODE;
//# sourceMappingURL=CheckboxGroup.constants.js.map